export default __webpack_public_path__ + "static/media/2013.a1a1ab84.png";